<template>
  <div>
    <b-modal
      id="confirmModal"
      v-bind:title="title"
      v-model="modalShow"
      @show="modalShowFunc"
      @hidden="modalHideFunc"
      @ok="okFunc"
      v-bind:no-close-on-backdrop="isBackDrop"
    >
      <div class="bodyContents">
        <p v-html="contents"></p>
      </div>
      <div slot="modal-footer">
        <b-btn class="confirmBtn modalBtn" @click="okFunc">동의</b-btn>
        <b-btn class="cancleBtn modalBtn" @click="closeFunc">취소</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { eventBus } from "@/main.js";

export default {
  data() {
    return {
      modalShow: false,
    };
  },
  computed: {
    ...mapState("modal", ["title", "contents", "isBackDrop"]),
  },
  methods: {
    ...mapActions("modal", ["setCallBackYn"]),
    modalShowFunc() {},
    modalHideFunc() {},
    okFunc() {
      this.$bvModal.hide("confirmModal");
      if (this.$store.state.modal.isCallbackFunc) {
        eventBus.$emit("callFromModal");
      }
    },
    closeFunc() {
      this.$bvModal.hide("confirmModal");
    },
  },
};
</script>
